module.exports = __webpack_public_path__ + "static/media/cnWicungo.cfc3ba5a.svg";